import React from "react";
import styled from "styled-components";
import SidebarItem from "../Sidebar/components/SidebarItem";
import { Link, useNavigate } from "react-router-dom";
import { selectSelectedSchool } from "app/modules/schools/selectors";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useSidebarMenuItems } from "../Sidebar/hooks";
import { Session } from "../Header/components/Session";
import { setSelectedSession } from "app/modules/schools/operations";
import {
  selectSession,
  selectActiveSession,
} from "app/modules/schools/selectors";
import { useDispatch } from "react-redux";

import { IconButton, Stack, Box, Divider, Avatar } from "@mui/material";
import SearcMenuInput from "../Sidebar/components/SearcMenuInput";
import SettingModal from "../Header/SettingsModal";
import { Settings, CurrencyRupee } from "@mui/icons-material";

const MobileSidebar = ({ setShow }) => {
  const menuItems = useSidebarMenuItems();
  const selectedSchool = useSelector(selectSelectedSchool);
  const location = useLocation();
  const pathname = location.pathname;
  const dispatch = useDispatch();

  const selectedSession = useSelector(selectActiveSession);
  const sessionlist = useSelector(selectSession);

  const [settingModalOpen, setSettingModalOpen] = React.useState(false);
  const navigate = useNavigate();
  const handleSettingModal = () => {
    // setSettingModalOpen((prev) => !prev);
    navigate("/settings/schoolSetting/school");
    //close the sidebar
    setShow(false);
  };

  const handleSessionSelection = (session) => {
    dispatch(setSelectedSession({ sessionName: session }));
  };

  return (
    <StyledWrapper>
      <SettingModal open={settingModalOpen} onClose={handleSettingModal} />
      <div className="side-nav-container">
        {/* Header Section with Logo and School Info */}
        <div className="nav-heading">
          <div className="nav-brand">
            <Avatar
              src={selectedSchool.schoolLogo}
              alt={selectedSchool.schoolName}
              sx={{
                width: 90,
                height: 90,
                margin: "20px auto",
                border: "3px solid rgba(255, 255, 255, 0.3)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              }}
            />
          </div>
          <Box sx={{ mt: 2, px: 2 }}>
            <p className="school-info">{selectedSchool.schoolName}</p>
          </Box>
        </div>

        <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.15)", my: 2 }} />

        {/* Session and Settings Controls */}
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          justifyContent="center"
          sx={{ width: "100%", px: 1.5, mb: 2 }}
        >
          <Session
            handleSessionSelection={handleSessionSelection}
            selectedSession={selectedSession}
            sessions={sessionlist}
          />
          <IconButton
            onClick={handleSettingModal}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: 2,
              p: 1,
            }}
          >
            <Settings
              sx={{
                fontSize: "22px",
                color: "#fff",
              }}
            />
          </IconButton>
          <IconButton
            onClick={() => navigate("/schools/school-profile?tab=transaction")}
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: 2,
              p: 1,
            }}
          >
            <CurrencyRupee
              sx={{
                fontSize: "22px",
                color: "#fff",
              }}
            />
          </IconButton>
        </Stack>

        {/* Navigation Menu */}
        <div className="nav-menu">
          <SearcMenuInput setShowMobile={setShow} />
          <div className="ul">
            {menuItems.map((item, index) => (
              <React.Fragment key={index}>
                {item.subMenu && item.subMenu.length > 0 ? (
                  <div className="ul-li" role="button">
                    <SidebarItem
                      key={item.key}
                      item={item}
                      isExpanded={true}
                      setShow={setShow}
                    />
                  </div>
                ) : (
                  <div
                    className={
                      pathname.includes(item.link)
                        ? "ul-li active-link"
                        : "ul-li"
                    }
                    role="button"
                  >
                    <Link
                      to={item.link}
                      className="link-hover"
                      onClick={() => setShow(false)}
                    >
                      <div className="menu-item-content">
                        <span className="icon-wrapper">{item.icon}</span>
                        <span className="name-wrapper">{item.name}</span>
                      </div>
                    </Link>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

export default MobileSidebar;

const StyledWrapper = styled.div`
  background: #084c84;
  width: 280px;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  }

  .school-info {
    padding: 0 16px;
    font-size: 15px;
    font-weight: 600;
    word-wrap: break-word;
    text-align: center;
    color: #fff;
    line-height: 1.4;
    margin: 0;
  }

  .side-nav-container {
    background: linear-gradient(180deg, #084c84 0%, #063a66 100%);
    height: 100%;
    position: relative;
    color: white;
    transition: 0.4s;
  }

  .nav-heading {
    padding-top: 10px;
  }

  .nav-brand-img {
    display: block;
    margin: 0 auto;
  }

  .nav-menu {
    margin-top: 16px;
    padding-bottom: 20px;
  }

  .menu-item-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 8px 12px 38px;
    transition: all 0.2s ease-in-out;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;

    svg {
      height: 20px;
      width: 20px;
      transition: transform 0.2s ease-in-out;
    }
  }

  .name-wrapper {
    flex: 1;
    margin-left: 16px;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ul {
    background: transparent;
    padding: 0;
    width: 100%;
    transition: 0.3s;
  }

  .ul-li {
    list-style: none;
    color: white;
    font-size: 14px;
    margin-bottom: 4px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease-in-out;
    border-radius: 0 12px 12px 0;
    margin-right: 8px;

    &:hover {
      background: rgba(255, 255, 255, 0.08);

      .icon-wrapper svg {
        transform: scale(1.1);
      }
    }

    a {
      text-decoration: none;
      color: white;
      display: block;

      &:hover {
        color: #fff;
      }
    }
  }

  .active-link {
    background: rgba(255, 255, 255, 0.95);
    position: relative;
    margin-right: 0;

    &:before {
      content: "";
      position: absolute;
      top: -20px;
      right: 0;
      width: 20px;
      height: 20px;
      background: transparent;
      border-radius: 50%;
      box-shadow: 10px 10px 0 rgba(255, 255, 255, 0.95);
    }

    &:after {
      content: "";
      position: absolute;
      bottom: -20px;
      right: 0;
      width: 20px;
      height: 20px;
      background: transparent;
      border-radius: 50%;
      box-shadow: 10px -10px 0 rgba(255, 255, 255, 0.95);
    }

    a {
      color: #084c84;
      font-weight: 600;
    }

    .icon-wrapper svg {
      color: #084c84;
    }

    &:hover {
      background: rgba(255, 255, 255, 1);
    }
  }

  .sidebar-content {
    padding-top: 0.25rem;
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease-in-out;
  }

  .ul-li.open .sidebar-content {
    padding-top: 0.25rem;
    height: auto;
  }
`;
